export default __webpack_public_path__ + "static/martini-designer-min-618b3bbbeb71f1b46ff6e5ab36051d85.png";